import { render, staticRenderFns } from "./ShopBundleProductList.vue?vue&type=template&id=328ff442"
import script from "./ShopBundleProductList.vue?vue&type=script&lang=js"
export * from "./ShopBundleProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports